<template>
  <div class="main-con el-main">
    <router-view />
  </div>
</template>

<script>
    export default {
        name: "FirstFinancing"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/FirstFinancing.vue